export const handlePending = (state) => {
  state.error = null;
  state.isLoading = true;
};

export const handleReject = (state, { payload }) => {
  state.error = payload;
  state.isLoading = false;
};

export const handleStoresFulfilled = (state, { payload }) => {
  state.stores = payload;
  state.error = null;
  state.isLoading = false;
};
